import { Box } from "../../components/ui/box";
import { Icon } from "../../components/ui/icon";
import { Text } from "../../components/ui/text";

/**
 * Rendered when a stored instance references a `type` no longer in the registry
 * (rolled-back deploy / removed widget). Degrades gracefully — never a crash.
 */
export function UnknownWidgetBody({ type }: { type: string }) {
  return (
    <Box fill align="center" justify="center" gap="xs" padding="sm">
      <Icon name="help-circle" size="lg" color="muted" />
      <Text size="sm" variant="muted" align="center">
        Unknown widget
      </Text>
      <Text size="xs" variant="muted" align="center" truncate>
        {type}
      </Text>
    </Box>
  );
}
